import { render, staticRenderFns } from "./DappContractList.vue?vue&type=template&id=03594194"
import script from "./DappContractList.vue?vue&type=script&lang=ts"
export * from "./DappContractList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports